import { http } from "@/lib/http";
import { withIdempotencyKey } from "@/lib/idempotency";
import { isMockEnabled } from "@/lib/mock-flags";
import * as mock from "../mocks/fixtures";
import type { CreateTicketInput, SupportTicket } from "../mocks/fixtures";

export const listTickets = async (): Promise<SupportTicket[]> => {
  if (isMockEnabled("support")) return mock.listTickets();
  const { data } = await http.get<SupportTicket[]>("/support/tickets");
  return data;
};

export const getTicket = async (
  id: string,
): Promise<SupportTicket | undefined> => {
  if (isMockEnabled("support")) return mock.getTicket(id);
  const { data } = await http.get<SupportTicket>(`/support/tickets/${id}`);
  return data;
};

export const createTicket = async (
  input: CreateTicketInput,
  idempotencyKey?: string,
): Promise<SupportTicket> => {
  if (isMockEnabled("support")) return mock.createTicket(input);
  const { data } = await http.post<SupportTicket>(
    "/support/tickets",
    input,
    withIdempotencyKey(idempotencyKey),
  );
  return data;
};

export const replyTicket = async (
  id: string,
  body: string,
): Promise<SupportTicket> => {
  if (isMockEnabled("support")) return mock.replyTicket(id, body);
  const { data } = await http.post<SupportTicket>(
    `/support/tickets/${id}/messages`,
    { body },
  );
  return data;
};

export type {
  SupportTicket,
  TicketMessage,
  TicketStatus,
  TicketPriority,
  TicketCategory,
  CreateTicketInput,
} from "../mocks/fixtures";
